import React, { PureComponent } from 'react';
import './Sun.css';

class Sun extends PureComponent {
	render() {
		return (
			<g className="Sun">
				<path className="ray" d="M15.578,8.515c-2.021-1.864-4.909-1.864-6.93,0c-2.02,1.862-1.751,5.032,0,6.931c1.862,2.02,5.032,1.752,6.931,0
					C17.598,13.582,17.33,10.414,15.578,8.515z M15.049,14.914c-1.582,1.717-4.26,1.486-5.871,0c-1.715-1.582-1.485-4.258,0-5.869
					c1.582-1.715,4.259-1.485,5.87,0C16.631,10.762,16.632,13.197,15.049,14.914z"/>
				<path className="ray" d="M7.711,7.896C7.917,8.102,8.235,7.784,8.03,7.578C7.175,6.723,6.32,5.869,5.465,5.014C5.26,4.809,4.942,5.126,5.147,5.332
					C6.002,6.187,6.856,7.042,7.711,7.896z"/>
				<path className="ray" d="M10.923,5.788c-0.185-0.746-0.371-1.491-0.556-2.237c-0.07-0.282-0.504-0.162-0.434,0.119
					c0.185,0.746,0.371,1.491,0.556,2.237C10.56,6.188,10.994,6.069,10.923,5.788z"/>
				<path className="ray" d="M14.064,6.371c0.25-1.234,0.498-2.468,0.747-3.702c0.058-0.283-0.376-0.404-0.434-0.119
					c-0.249,1.234-0.498,2.468-0.747,3.702C13.574,6.535,14.008,6.656,14.064,6.371z"/>
				<path className="ray" d="M16.34,8.071c0.498-0.497,0.994-0.995,1.492-1.492c0.205-0.206-0.113-0.523-0.318-0.318
					c-0.498,0.497-0.994,0.995-1.492,1.492C15.816,7.958,16.135,8.276,16.34,8.071z"/>
				<path className="ray" d="M16.556,16.104c-0.206-0.205-0.523,0.113-0.318,0.318c0.854,0.855,1.71,1.709,2.564,2.564
					c0.206,0.205,0.523-0.113,0.318-0.318C18.266,17.814,17.41,16.959,16.556,16.104z"/>
				<path className="ray" d="M13.344,18.213c0.186,0.746,0.37,1.492,0.556,2.236c0.069,0.281,0.504,0.162,0.434-0.119
					c-0.185-0.746-0.37-1.49-0.556-2.236C13.707,17.812,13.273,17.932,13.344,18.213z"/>
				<path className="ray" d="M10.202,17.629c-0.249,1.234-0.498,2.469-0.747,3.701c-0.057,0.283,0.376,0.404,0.434,0.121
					c0.249-1.234,0.498-2.469,0.747-3.703C10.693,17.465,10.259,17.344,10.202,17.629z"/>
				<path className="ray" d="M3.357,10.632c0.758,0.126,1.516,0.252,2.273,0.378c0.284,0.047,0.405-0.386,0.119-0.434
					c-0.758-0.126-1.516-0.252-2.273-0.378C3.193,10.151,3.071,10.584,3.357,10.632z"/>
				<path className="ray" d="M6.029,13.709c-1.215,0.326-2.431,0.652-3.646,0.979c-0.28,0.076-0.161,0.51,0.119,0.434
					c1.216-0.326,2.432-0.652,3.647-0.979C6.429,14.068,6.31,13.633,6.029,13.709z"/>
				<path className="ray" d="M20.551,13.875c-0.725-0.258-1.447-0.516-2.172-0.773c-0.273-0.098-0.391,0.336-0.119,0.434
					c0.724,0.258,1.447,0.516,2.171,0.773C20.705,14.406,20.822,13.973,20.551,13.875z"/>
				<path className="ray" d="M21.498,9.241c-1.209,0.351-2.417,0.702-3.626,1.054c-0.278,0.081-0.159,0.515,0.12,0.434
					c1.209-0.351,2.417-0.702,3.626-1.054C21.896,9.594,21.777,9.159,21.498,9.241z"/>
				<path className="ray" d="M7.926,15.93c-0.497,0.498-0.994,0.994-1.491,1.492c-0.205,0.205,0.113,0.523,0.318,0.318
					c0.497-0.498,0.994-0.996,1.491-1.492C8.45,16.043,8.132,15.725,7.926,15.93z"/>
			</g>
		);
	}
}

export default Sun;